import { saveAs } from 'file-saver'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

// UI
import { Button, Flex, Heading } from '@chakra-ui/react'

// Components

// Hooks
import useOfferList from '@/features/offers/hooks/useOfferList'

// Constants

// Helpers
import { createExcelFromAoA } from '@/utils/fileHelper'
import { buildDownloadRow } from './mySourcingDownload'

// Slices
import TableProfileMenu from '@/components/TableProfileMenu'
import { showCreateOfferModal } from '@/stores/offers/offersSlice'
import { camelToWords } from '@/utils/stringHelper'
import { MySourcingOfferDisplayLevel } from '@/features/tableProfiles/constants/tableProfile.constant'

// Components
const MySourcingPageHeader = ({
  count = 0,
  query = {},
  tableState = {},
  setTableState,
  userTableProfile,
  URLSelectedProfileId,
  displayLevel,
  setTableDisplayLevel,
}) => {
  const { useFetchMySourcingOffers } = useOfferList()
  const dispatch = useDispatch()

  const { data: allOffersResponse, isLoading } = useFetchMySourcingOffers(
    { ...query, page: 1, pageSize: 0 },
    displayLevel
  )

  const handleDownloadOffer = useCallback(() => {
    try {
      if (!tableState?.columnVisibility) {
        toast.error('Column visibility is not set. Please configure the table first.')
        return
      }
      if (!Array.isArray(tableState?.columnOrder)) {
        toast.error('Column visibility is not set. Please configure the table first.')
        return
      }

      const headerKeys = []
      Object.entries(tableState.columnVisibility).forEach(([key, value]) => {
        if (key === 'action') return
        if (value) {
          headerKeys.push(key)
        }
      })
      const labelKeys = [...headerKeys].map((key) =>
        camelToWords(key.replace(new RegExp('commercialCheckList|legal', 'g'), ''))
      )

      const rowData = allOffersResponse?.data?.map((data) => buildDownloadRow(data, headerKeys))

      const excelBlob = createExcelFromAoA([labelKeys, ...rowData])

      saveAs(excelBlob, 'My Offers.xlsx')
    } catch (err) {
      console.error(err)
      toast.error('Failed to download offers.')
    }
  }, [allOffersResponse?.data, tableState])

  const handleCreate = useCallback(() => {
    dispatch(showCreateOfferModal({}))
  }, [dispatch])

  return (
    <Flex py="5" borderBottom="1px solid #d8dbe0" alignItems={'center'} gap="3">
      <Heading mr="5">My Sourcing ({count})</Heading>
      <TableProfileMenu
        userTableProfile={userTableProfile}
        tableState={tableState}
        setTableState={setTableState}
        tableDisplayLevel={displayLevel}
        setTableDisplayLevel={setTableDisplayLevel}
        URLSelectedProfileId={URLSelectedProfileId}
        allDisplayLevels={[
          {
            value: MySourcingOfferDisplayLevel.COST_BUDGET,
            label: `Display Every Cost Budget`,
          },
          {
            value: MySourcingOfferDisplayLevel.COST_BUDGET_RFQ,
            label: `Display Every Cost Budget - RFQ`,
          },
          {
            value: MySourcingOfferDisplayLevel.PR,
            label: `Display Every PR`,
          },
          {
            value: MySourcingOfferDisplayLevel.PR_LINE_ITEM,
            label: `Display Every PR - Line Item`,
          },
        ]}
      />
      <Flex gap="2">
        <Button colorScheme="gray" onClick={handleDownloadOffer} isLoading={isLoading} loadingText="Downloading">
          Download
        </Button>
        <Button colorScheme="blue" onClick={handleCreate}>
          Create Offer
        </Button>
      </Flex>
    </Flex>
  )
}

export default MySourcingPageHeader
